module.exports = __webpack_public_path__ + "img/step2-c.c61cb01f.png";